var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{ref:"barchart",attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }